import { useEffect } from "react";

/**
 * Loads Wistia embed scripts only once per page.
 * Call this hook at the top level of any page or layout that uses Wistia embeds.
 */
export default function useWistiaScript() {
  useEffect(() => {
    // Only add scripts if not already present
    if (!document.querySelector("script[src*=\"fast.wistia.com/embed/medias\"]")) {
      const script1 = document.createElement("script");
      script1.src = "https://fast.wistia.com/embed/medias.jsonp"; // Loads all medias
      script1.async = true;
      document.body.appendChild(script1);
    }
    if (!document.querySelector("script[src=\"https://fast.wistia.com/assets/external/E-v1.js\"]")) {
      const script2 = document.createElement("script");
      script2.src = "https://fast.wistia.com/assets/external/E-v1.js";
      script2.async = true;
      document.body.appendChild(script2);
    }
    // No cleanup: scripts should persist for all embeds on the page
  }, []);
}
